import { Link } from "react-router-dom";
import { ArrowLeft, Compass, LifeBuoy } from "lucide-react";
import { Reveal } from "@/lib/motion";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="relative flex min-h-screen items-center pt-40 pb-28 lg:pt-32">
      <div className="pointer-events-none absolute inset-x-0 top-0 -z-10 h-80 spotlight opacity-60" />
      <div className="mx-auto w-full max-w-3xl px-5 lg:px-8">
        <Reveal>
          <div className="glass-card rounded-[2.5rem] p-8 text-center sm:p-14">
            <div className="mb-4 text-xs uppercase tracking-[0.3em] text-[#8B5CF6]">Fehler 404</div>
            <div className="font-display text-7xl font-bold tracking-tighter text-gradient sm:text-8xl">404</div>
            <h1 className="mt-4 font-display text-3xl font-bold tracking-tighter text-white sm:text-4xl">
              Seite nicht gefunden
            </h1>
            <p className="mx-auto mt-4 max-w-md text-base leading-relaxed text-white/60">
              Diese Seite gibt es nicht (mehr) – vielleicht ist der Link veraltet oder du hast dich
              vertippt. Zurück zur Crew geht’s hier:
            </p>
            <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
              <Link
                to="/"
                data-testid="not-found-home-link"
                className="btn-primary group inline-flex items-center gap-2 px-7 py-3.5 text-sm font-medium"
              >
                <ArrowLeft className="h-4 w-4 transition-transform group-hover:-translate-x-1" />
                Zur Startseite
              </Link>
              <Link
                to="/features"
                data-testid="not-found-features-link"
                className="btn-ghost inline-flex items-center gap-2 px-7 py-3.5 text-sm font-medium"
              >
                <Compass className="h-4 w-4" />
                Features entdecken
              </Link>
              <Link
                to="/support"
                data-testid="not-found-support-link"
                className="btn-ghost inline-flex items-center gap-2 px-7 py-3.5 text-sm font-medium"
              >
                <LifeBuoy className="h-4 w-4" />
                Support
              </Link>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  );
}
